import { Button } from "antd";
import { useState } from "react";
import DetachCandidateModal from "./detachCandidateModal/detachCandidateModal";

export default function DetachCandidateButton({
  candidateActivity,
  styles,
  classId,
  onSuccess,
  disabled = false,
}) {
  const [detachCandidateModal, setDetachCandidateModal] = useState({
    showModal: false,
    isLoading: false,
    detachResponse: null,
  });

  const handleDetachCandidate = () => {
    setDetachCandidateModal((prev) => ({ ...prev, showModal: true }));
  };

  return (
    <>
      <Button
        className={`${styles.deleteBtn} btn-detached`}
        type="link"
        icon={<i className="icon-detach" />}
        disabled={disabled}
        onClick={handleDetachCandidate}
      />

      <DetachCandidateModal
        classId={classId}
        candidateActivity={candidateActivity}
        detachCandidateModal={detachCandidateModal}
        setDetachCandidateModal={setDetachCandidateModal}
        onSuccess={onSuccess}
      />
    </>
  );
}
